import React, { useState } from 'react';
import { IconAlertCircle } from '@tabler/icons-react';
import { CustomerData } from '../../../../models/authUserModel';
import PhoneNumberForm from './PhoneForm/PhoneForm';
import ProfileForm from './PersonalForm/PersonalForm';
import DocumentForm from './DocumentForm/DocumentForm';

interface Tab {
  id: string;
  label: string;
}
export interface TabsComponentProps {
  customerInfo?: CustomerData;
}

const TabsComponent = ({customerInfo}: TabsComponentProps) => {
  const [activeTab, setActiveTab] = useState<string>('profile');

  // Estado de cada tab: true = completado, false = pendiente
  const [tabStatus] = useState<{ [key: string]: boolean }>({
    profile: false,
    dashboard: customerInfo?.required_actions?.require_phone_verification || false,
    documentation: customerInfo?.required_actions?.require_documents || false,
    settings: true,
  });

  const tabs: Tab[] = [
    { id: 'profile', label: 'Datos personales' },
    { id: 'dashboard', label: 'Número Telefónico' },
    { id: 'documentation', label: 'Documentación' },
    
  ];

  const handleTabClick = (tabId: string): void => {
    setActiveTab(tabId);
  };

  

  return (
    <div className="w-full mx-auto p-4">
      {/* Tab Headers */}
      <div className="border-b border-gray-300">
  <nav
    className="
      flex flex-nowrap overflow-x-auto no-scrollbar -mb-px
      md:flex-wrap md:overflow-visible
    "
    role="tablist"
  >
    {tabs.map((tab: Tab) => (
      <button
        key={tab.id}
        onClick={() => handleTabClick(tab.id)}
        className={`
          relative px-6 py-4 text-base font-medium transition-all duration-300 ease-in-out
          flex items-center gap-2 shrink-0
          ${activeTab === tab.id 
            ? 'text-blue-600 border-b-4 border-[#212121]' 
            : 'text-gray-600 border-b-4 border-transparent'
          }
          hover:text-blue-600 focus:outline-none
        `}
        role="tab"
        aria-selected={activeTab === tab.id}
        aria-controls={`panel-${tab.id}`}
        id={`tab-${tab.id}`}
      >
        {tab.label}
        {tabStatus[tab.id] && <IconAlertCircle className="text-yellow-500 w-5 h-5" />}
      </button>
    ))}
  </nav>
</div>


      {/* Tab Content */}
      <div className="relative mt-8">
        {tabs.map((tab: Tab) => (
          <div
            key={tab.id}
            id={`panel-${tab.id}`}
            className={`
              transition-all duration-500 ease-in-out
              ${activeTab === tab.id 
                ? 'opacity-100 translate-x-0 relative' 
                : 'opacity-0 translate-x-8 absolute inset-0 pointer-events-none'
              }
            `}
            role="tabpanel"
            aria-labelledby={`tab-${tab.id}`}
            hidden={activeTab !== tab.id}
          >
            <div className="lg:px-6 space-y-6 md:space-y-8">
              {tab.id === 'profile' && (
                <ProfileForm customerInfo={customerInfo} />
              )}

              {tab.id === 'dashboard' && (
               <PhoneNumberForm customerInfo={customerInfo} />
              )}
               {tab.id === 'documentation' && (
                <DocumentForm customerInfo={customerInfo}/>
              )}

              {tab.id === 'settings' && (
                <div className="flex flex-col md:flex-row md:items-center md:justify-between md:gap-4">
                  <label className="w-full md:w-1/4 text-gray-700 font-medium">Address</label>
                  <input
                    type="text"
                    className="w-full md:w-3/4 border border-gray-300  px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="123 Main St"
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Mobile indicator */}
      <div className="mt-6 text-center text-sm text-gray-500 md:hidden">
        Desliza para ver todas las tabs
      </div>
    </div>
  );
};

export default TabsComponent;
